export default {
  categories: [],
  category: {},
  categoryHelpers: {}
}



// WEBPACK FOOTER //
// ./src/components/category/store/state.js